module.exports = __webpack_public_path__ + "static/media/bronze-crown.e9b54a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bronze-crown.png
// module id = 664
// module chunks = 0